import { GalleryProduct } from 'shared/components/ProductGalleryCard/typings';
import { Channel, Segment } from 'shared/hooks';

export interface BuildTrackingProductData {
  product: GalleryProduct;
  promoDealString?: string;
  promoTag?: string;
  segment: Segment;
  channel: Channel;
}

export function buildTrackingProductData({
  product,
  promoDealString,
  promoTag,
  segment,
  channel,
}: BuildTrackingProductData) {
  return [
    {
      productInfo: {
        productID: product.defaultPlan?.id ?? product.offerId,
        productName: product.name,
        sku: 'SKU', // Get this value from BM once its available later
        productImage: product.imageUrl,
      },
      category: {
        primaryCategory: product.dataLayerCategory,
      },
      attributes: {
        displayName: product.name,
        isGSTIncluded: segment === 'personal',
        baseStore: channel,
        segment,
        itemBasePrice: product.basePrice?.toString(),
        itemOneOffCost:
          product.priceType?.toLowerCase() === 'onetime'
            ? product.basePrice?.toString()
            : '0.00',
        itemRecurringCost:
          product.priceType?.toLowerCase() === 'recurring'
            ? product.basePrice?.toString()
            : '0.00',
        promoMessage: product.pricePointCreditDescription,
        promoTag,
        promoDeals: promoDealString,
        badgeMessage: product.tag,
        isPreOrder: Boolean(product.productCharacteristics?.preOrderable),
        isInStock: product.stockStatus !== 'OUT_OF_STOCK',
        stockInfo: {
          isInStockWarehouse:
            product.stockStatus === 'ONLINE_ONLY' ||
            product.stockStatus === 'IN_STOCK',
          isInStockStore:
            product.stockStatus === 'STORE_ONLY' ||
            product.stockStatus === 'IN_STOCK',
        },
      },
      quantity: '1',
    },
  ];
}
